import { render, staticRenderFns } from "./VUDNumbers.vue?vue&type=template&id=63ee0953&"
import script from "./VUDNumbers.vue?vue&type=script&lang=js&"
export * from "./VUDNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports